import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import callApi from "../../Apis/callApi";
import WithTableView from "../../GenericPages/WithTableView";
import axios from "axios";
import Loading from "../../Components/Loading";

const CompanyData = () => {
  const [company, setCompany] = useState<any>([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const getData = () => {
    callApi({
      url: "getAllCompany",
      method: "get",
      type: "company",
    })
      .then((res) => {
        setCompany(res.data.data.company);
        setLoading(false);
      })
      .catch((_e) => {
        toast.error("Something went wrong!");
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const handleDelete = (val: any, id: any) => {
    toast.promise(
      new Promise((resolve, reject) => {
        axios({
          url: `https://www.ahinternational.online/v1/company/deleteCompany/${id}`,
          method: "delete",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token_AHI")}`,
          },
        })
          .then((res) => {
            getData();
            resolve(true);
          })
          .catch((_e) => {
            reject(false);
          });
      }),
      {
        loading: "Deleting...",
        success: "Deleted!",
        error: "Something went wrong!",
      }
    );
  };

  return (
    <>
      <Loading isLoading={loading} />
      <WithTableView
        heading="Company Data"
        head={[
          { title: "S.No." },
          { title: "Company Name" },
          { title: "Type" },
          { title: "Country" },
          { title: "Mobile" },
          { title: "Email" },
          { title: "" },
        ]}
        body={company.map((el: any) => {
          return {
            _id: el._id,
            companyName: el.companyName,
            type: el.type,
            country: el.country,
            mobile: el.mobile,
            emailAdd1: el.emailAdd1,
          };
        })}
        body_keys={[
          "companyName",
          "type",
          "country",
          "mobile",
          "emailAdd1",
          "action:delete",
        ]}
        show_btn_1={true}
        btn1Text="Add new"
        btn1Type="filled"
        onRowClick={(val: any) => {
          navigate(`/company-data/update_company-data/${val._id}`);
        }}
        onClickHandler={() => {
          navigate("/company-data/create");
        }}
        onActionClick={handleDelete}
      />
    </>
  );
};

export default CompanyData;
